import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon']): NavItem => ({ label, path, icon, module: Modules.Property, permission: Perm.Property.View });

/**
 * The property module's navigation: one Property menu, grown phase by phase (leasing, billing,
 * maintenance and compliance join the register). Shown only where the organisation has the module on.
 */
export const propertyNavEntries: NavEntry[] = [
  item('Overview', '/property', DashboardOutlinedIcon),
  item('Register', '/property/register', AccountTreeOutlinedIcon),
  item('Leasing', '/property/leasing', HandshakeOutlinedIcon),
  item('Billing', '/property/billing', ReceiptLongOutlinedIcon),
  item('Assets', '/property/assets', PrecisionManufacturingOutlinedIcon),
  item('Work', '/property/work', BuildOutlinedIcon),
  item('Contractors and costs', '/property/contractors', EngineeringOutlinedIcon),
  item('Map', '/property/map', MapOutlinedIcon),
  // Obligations, regulators' findings and evidence packs: every sector has them, so the entry stands on its own.
  item('Compliance', '/property/compliance', VerifiedUserOutlinedIcon),
  // The airport pack (docs \u00a7216): shown only where a portfolio the person sees has the pack on.
  { ...item('Airport', '/property/airport', FlightTakeoffOutlinedIcon), feature: 'property.airport' },
  // The field app (docs §215): for anyone with the field-work right, in its own mobile frame.
  { label: 'Field app', path: '/field', icon: PhoneAndroidOutlinedIcon, module: Modules.Property, permission: Perm.Property.FieldWork },
  item('Property Settings', '/property/settings', SettingsOutlinedIcon),
];

export const propertyNavGroup: NavGroup = {
  kind: 'group', key: 'property', label: 'Property', icon: HomeWorkOutlinedIcon, items: propertyNavEntries,
};
